import axios from "axios";
import axiosRetry from "axios-retry";
import { codeBundleId } from "@lib/sentry";
import getCatalogueName from "@utils/getCatalogueName";
import getUserLanguage from "@utils/getUserLanguage";
import { searchBaseURL, appVersion, appVersionCode } from "../config";
import {
  onFulfilledRequestInterceptor,
  onFulfilledResponseInterceptor,
  onRejectedResponseInterceptor,
} from "./api-utils";

const searchApi = axios.create({
  baseURL: searchBaseURL,
  timeout: 10000,
  headers: {
    "x-app-name": "CPDB",
    "x-app-version": appVersion,
    "x-app-version-cp": codeBundleId,
    "x-app-version-code": appVersionCode,
    "use-applinks-cl": "true",
  },
});

axiosRetry(searchApi, { retryDelay: axiosRetry.exponentialDelay, retries: 3 });

searchApi.interceptors.request.use(onFulfilledRequestInterceptor);

searchApi.interceptors.response.use(
  onFulfilledResponseInterceptor,
  onRejectedResponseInterceptor,
);

export const getProductsBySearch = (searchTerm) =>
  searchApi.post("/cpdb/search-product-new", { product: searchTerm });

export const searchProducts = (searchTerm = "") =>
  searchApi.get(`/cpdb/search/products?searchTerm=${searchTerm}`);

export const suggestFromKeyword = (search_term = "") => {
  const catalogue_name = getCatalogueName();
  return searchApi.get(
    `v1/suggest?search_term=${search_term}&catalogue_name=${catalogue_name}`,
    {
      removeAuth: true,
    },
  );
};

export const searchKeyword = (linkParam) =>
  searchApi.get(`v1/search${linkParam}`);

export const searchRawKeyword = (search_term = "") =>
  searchApi.get(`v1/search?search_term=${search_term}`);

export const getTrendingSearch = () =>
  searchApi.get(`v1/search/trending?lang=${getUserLanguage()}`);

export { searchApi };
